module.exports = __webpack_public_path__ + "static/media/food-line-6.b3f0cf41.jpg";